import React from "react";

export const formatPriceStyle = (price,disableStyle=false) => {

    if(!price) return null;

    price = price.toString();

    const priceParts = price.split('.');
    const priceInt = priceParts[0];
    const priceDec = priceParts[1];
    return <span className={!disableStyle ? 'text-lg lg:text-2xl' : undefined}>{priceInt},<span className={!disableStyle ? 'text-sm lg:text-lg' : undefined}>{priceDec}</span></span>
}
export const formatCurrencySymbol = (currency) => {
    if (currency === 'EUR') {
        return '€';
    } else if (currency === 'USD') {
        return '$';
    } else if (currency === 'GBP') {
        return '£';
    } else if (currency === 'AUD') {
        return 'A$';
    }

    return currency;
}

export const roundPrice = (num) => {
    //console.log(Number.EPSILON);
    let price = parseFloat(num);
    //return Math.round(parseFloat(price) * 100) / 100;
    let decimals = String(price).indexOf(".") !== -1 ? String(price).split(".")[1] : null;

    if(!decimals){
        return price;
    }

    for(let i  = 2; i < decimals.length; i++){
        if(decimals[i]%5===0 && decimals[i]%10!==0){
            //console.log("found 5 = pos " + i);
            price = price + ( 1 / Math.pow(10, i + 1));
            break;
        }
    }

    //let fixN =  ((price*1000) % 5 === 0 && (price*1000) % 10 !== 0 ) ? Math.ceil ( (price*100) + 0.1 ) / 100 : Math.round(parseFloat(price) * 100) / 100;
    let fixN = parseFloat((Math.round(price * 1000) / 1000).toFixed(2));
    return fixN;
}